<template>
  <div class="data-list">
    <div v-for="(item, index) in list" :key="index" class="line-data">
      <div class="line-content">
        <span class="circle"></span>
        <span class="text">{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-list{
  width: 100%;
  height: 100%;
  .line-data{
    position: relative;
    line-height: 40px;
    overflow: hidden;
    .line-content{
      display: flex;
      align-items: center;
      .circle{
        display: inline-block;
        flex: 0 0 9px;
        height: 9px;
        background-color: #00af84;
        border-radius: 50%;
        margin-right: 15px;
      }
      .text{
        flex:1;
        font-family: MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #464C5E;
      }
    }

  }

}
</style>

